package xim.poc.game.configuration.v0.tactics

import xim.poc.game.QueryMenuOption
import xim.poc.game.QueryMenuResponse
import xim.poc.game.UiStateHelper
import xim.poc.game.configuration.v0.GameV0SaveStateHelper

class TacticsSettingSelectUi {

    private val options = makeOptions()

    fun push() {
        UiStateHelper.openQueryMode("Which setting?", enableCursorMovementKeys = true, options = options) {
            handleResponse(it)
        }
    }

    private fun makeOptions(): MutableList<QueryMenuOption> {
        val state = GameV0SaveStateHelper.getState().tacticsState

        return mutableListOf(
            QueryMenuOption("Enemy turn speed: ${state.enemyTurnSpeed}x", 0),
            QueryMenuOption("Skill animation speed: ${state.skillAnimationSpeed}x", 1),
            QueryMenuOption("Confirm 'Wait': ${state.confirmWait}", 2),
            QueryMenuOption("Close", -1),
        )
    }

    private fun handleResponse(queryMenuOption: QueryMenuOption?): QueryMenuResponse {
        if (queryMenuOption == null || queryMenuOption.value < 0) { return QueryMenuResponse.pop }

        val state = GameV0SaveStateHelper.getState().tacticsState

        if (queryMenuOption.value == 0) {
            state.enemyTurnSpeed = ((state.enemyTurnSpeed + 1) % 5).coerceIn(1, 4)
        }

        if (queryMenuOption.value == 1) {
            state.skillAnimationSpeed = ((state.skillAnimationSpeed + 1) % 5).coerceIn(1, 4)
        }

        if (queryMenuOption.value == 2) {
            state.confirmWait = !state.confirmWait
        }

        options.clear()
        options += makeOptions()

        return QueryMenuResponse.noop
    }

}